@if (isCityLoading()) {
<div class="text-sm font-medium text-slate-500">
  City data loading...
</div>
} @else {
  @if (locationErrorMsg) {
  <div class="text-xs font-medium text-rose-600 mb-2">
    {{ locationErrorMsg }}
  </div>
  }

  <p-select
    [options]="items"
    [(ngModel)]="selected"
    (onChange)="onChange()"
    [optionLabel]="'city'"
    [showClear]="false"
    [filter]="false"
    [placeholder]="'Select location'"
    class="locationDropdown"
  >
    <ng-template pTemplate="item" let-item>
      <div class="loc-option flex items-center gap-3">
        <div class="flex flex-col">
          <span class="text-slate-800 f12 font-medium leading-tight">
            {{ item?.city || 'Unknown city' }}, {{ item?.country || 'Unknown country' }}
          </span>
        </div>
      </div>
    </ng-template>

    <ng-template pTemplate="selectedItem" let-item>
      <div class="loc-option flex items-center gap-3">
        <div class="flex flex-col">
          <span class="text-slate-800 f12 font-medium leading-tight">
            {{ item?.city || 'Unknown city' }}, {{ item?.country || 'Unknown country' }}
          </span>
        </div>
      </div>
    </ng-template>
  </p-select>

  <p-dialog
    header="Change city"
    [(visible)]="confirmVisible"
    [modal]="true"
    [closable]="false"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: '420px' }"
  >
    <div class="text-sm text-slate-700">
      Changing city will remove all added simulations for the current city. Do you want to continue?
    </div>

    <ng-template pTemplate="footer">
      <button type="button" class="px-3 py-2 text-xs rounded-md bg-surface-200" (click)="cancelCityChange()">No</button>
      <button type="button" class="px-3 py-2 text-xs rounded-md bg-rose-600 text-white" (click)="confirmCityChange()">Yes</button>
    </ng-template>
  </p-dialog>
}